import { SvgIcon, SvgIconProps } from '@mui/material'

const Refresh = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 3.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .75-.75ZM3 11.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0v-8a.75.75 0 0 1 .75-.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 11.25a.75.75 0 0 1 .75.75 8.25 8.25 0 0 0 13.98 5.936.75.75 0 0 1 1.04 1.08A9.72 9.72 0 0 1 12 21.75c-5.385 0-9.75-4.365-9.75-9.75a.75.75 0 0 1 .75-.75ZM4.985 5.23A9.724 9.724 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75a.75.75 0 0 1-1.5 0A8.25 8.25 0 0 0 6.064 6.27a.75.75 0 1 1-1.08-1.04Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default Refresh
